import * as React from 'react';
import { Row } from 'react-bootstrap';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import CompanyFeatureFlagsEnum, { CompanyFeatureFlagsTips } from 'ab-enums/companyFeatureFlags.enum';

import PreviewItem from '../../Shared/PreviewItem';
import SettingPreview from '../../Shared/SettingPreview';

type Props = {
	isJobTrackingEnabled: boolean;
	syncTime: number;
	toggleEdit: () => void;
};

const EnableJobTrackingPreview: React.FC<Props> = (props: Props) => {
	const { isJobTrackingEnabled, toggleEdit, syncTime } = props;

	const startTimeFormatted = TimeUtils.minutesToTime(syncTime, TimeFormat.TIME_ONLY_12H);

	return (
		<SettingPreview toggleEdit={toggleEdit}>
			<div className="company-settings__info-segment">
				<PreviewItem
					checked={!!isJobTrackingEnabled}
					hint={CompanyFeatureFlagsTips.jobTracking}
					indent={false}
					label={CompanyFeatureFlagsEnum.isJobTrackingEnabled}
					showCheckbox={true}
				/>
				{!!isJobTrackingEnabled &&
					<Row className="row--padded">
						<div>
							<strong>
								{startTimeFormatted}
							</strong>
						</div>
					</Row>
				}
			</div>
		</SettingPreview>
	);
};

export default React.memo(EnableJobTrackingPreview);
